import React, { useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import Alert from 'react-bootstrap/Alert';
import Button from '@material-ui/core/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Link from '@material-ui/core/Link';
import Row from 'react-bootstrap/Row';
import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';
import Modal from 'react-bootstrap/Modal';
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';
import backgroundImg from './assets/background-new.png';
import qs from 'query-string';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    overflow: 'auto',
  },
  row: {
    height: '100%',
    alignItems: 'center',
  },
  hwLogo: {
    width: '135px',
    height: '135px',
  },
  title: {
    fontWeight: 'bold',
    textAlign: 'center',
    lineHeight: '99.6%',
    letterSpacing: '-0.04rem',
    color: '#6D61AB',
    margin: '20px 0px 25px 0px',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '325px',
      fontSize: 25,
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: '440px',
      fontSize: 36,
    },
  },
  formWrapper: {
    width: '100%',
  },
  label: {
    color: theme.palette.secondary.main,
  },
  login: {
    width: '100%',
    borderRadius: '4px',
    fontSize: 24,
    textTransform: 'none',
    margin: '10px 0px 15px 0px',
  },
  alertHeading: {
    marginBottom: 0,
  },
  registerCard: {
    marginTop: '20px !important',
    padding: '20px 45px !important',
  },
  registerTitle: {
    margin: '0',
    fontSize: 24,
    fontWeight: 500,
    lineHeight: '31px',
    letterSpacing: '-0.04rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
  },
  forgotPassword: {
    color: theme.palette.secondary.main,
    textDecoration: 'underline',
    fontSize: 18,
    marginTop: 11,
    lineHeight: '23px',
    letterSpacing: '-0.04em',
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

const { Group, Label, Control } = Form;

const PageWrapper = styled.div`
  background: url(${backgroundImg});
  background-size: cover;
  background-repeat: no-repeat;
  height: 100%;
`;

const Card = styled.div`
  background: #ffffff;
  width: 100%;
  max-width: 550px;
  margin: 0 auto;
  border-radius: 8px;
  height: auto;
  padding-top: 30px;
  padding-bottom: 15px;
  padding-left: 45px;
  padding-right: 45px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LoginPage = () => {
  const classes = useStyles();
  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const resetEmailRef = useRef(null);
  // NO VALIDATION RN ... waiting for design
  const [modalShow, setModalShow] = useState(false);
  const [alertShow, setAlertShow] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');

  const history = useHistory();

  const handleClickOpen = () => {
    setModalShow(true);
  };

  const handleClose = () => {
    setModalShow(false);
  };

  return (
    <PageWrapper>
      <Container fluid className={classes.root}>
        <Row className={classes.row}>
          <Col xs={0} sm={0} md={1} lg={2} xl={2} />
          <Col>
            <Card>
              {alertShow && (
                <Alert
                  variant="danger"
                  onClose={() => setAlertShow(false)}
                  dismissible>
                  <Alert.Heading className={classes.alertHeading}>
                    {alertMessage}
                  </Alert.Heading>
                </Alert>
              )}
              <img
                src={require('./assets/hw-logo.png')}
                alt="hw-logo"
                className={classes.hwLogo}
              />
              <p className={classes.title}>
                Hack Western 7 Application Portal Login
              </p>
              <Form
                className={classes.formWrapper}
                onSubmit={(event) => {
                  const form = event.currentTarget;
                  event.preventDefault();
                  event.stopPropagation();

                  if (form.checkValidity()) {
                    const link =
                      process.env.NODE_ENV === 'production'
                        ? process.env.REACT_APP_DROPLET_URL + '/api/user/login'
                        : 'http://localhost:8080/api/user/login';

                    axios
                      .post(
                        link,
                        {
                          email: emailRef.current.value,
                          password: window.btoa(passwordRef.current.value),
                        },
                        {
                          withCredentials: true,
                        }
                      )
                      .then((response) => {
                        let { redirect } = qs.parse(window.location.search);
                        console.log(redirect);
                        emailRef.current.value = '';
                        passwordRef.current.value = '';
                        if (redirect) {
                          history.push(redirect);
                        } else {
                          history.push('/dashboard');
                        }
                      })
                      .catch((error) => {
                        passwordRef.current.value = '';
                        setAlertMessage(
                          error.response.status === 401
                            ? 'Incorrect email and/or password'
                            : 'Looks like something’s wrong on our end, please try again later. if the problem still happens please send us a message at hello@hackwestern.com'
                        );
                        setAlertShow(true);
                      });
                  }
                }}>
                <Group>
                  <Label>
                    <Typography variant="h3" className={classes.label}>
                      Email
                    </Typography>
                  </Label>
                  <Control
                    type="email"
                    placeholder="Enter email"
                    ref={emailRef}
                  />
                  <Control.Feedback type="invalid">
                    Invalid email
                  </Control.Feedback>
                  <Control.Feedback>Looks good!</Control.Feedback>
                </Group>
                <Group>
                  <Label>
                    <Typography variant="h3" className={classes.label}>
                      Password
                    </Typography>
                  </Label>
                  <Control
                    type="password"
                    minLength={8}
                    placeholder="Enter password"
                    ref={passwordRef}
                  />
                  <Control.Feedback type="invalid">
                    Invalid password
                  </Control.Feedback>
                  <Control.Feedback>Looks good!</Control.Feedback>
                </Group>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  className={classes.login}>
                  Login
                </Button>
              </Form>
              <p className={classes.forgotPassword}>
                <Link onClick={handleClickOpen}>Forgot your password?</Link>
              </p>
              <Modal
                show={modalShow}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header>
                  <Modal.Title id="contained-modal-title-vcenter">
                    Reset Password
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <h4>Please Enter Your Email</h4>
                  <p>
                    If we find you in our system, we'll email you a link that
                    you can use to reset your password.
                  </p>
                  <Form
                    className={classes.formWrapper}
                    onSubmit={(event) => {
                      const form = event.currentTarget;
                      event.preventDefault();
                      event.stopPropagation();

                      if (form.checkValidity()) {
                        const link =
                          process.env.NODE_ENV === 'production'
                            ? process.env.REACT_APP_DROPLET_URL +
                              '/api/user/forgotPassword'
                            : 'http://localhost:8080/api/user/forgotPassword';
                        fetch(link, {
                          method: 'POST',
                          headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                          },
                          credentials: 'include',
                          body: JSON.stringify({
                            email: resetEmailRef.current.value,
                          }),
                        })
                          .then((_res) => {
                            handleClose();
                          })
                          .catch((err) => {
                            resetEmailRef.current.value = '';
                          });
                      }
                    }}>
                    <Group>
                      <Label>
                        <Typography variant="h3" className={classes.label}>
                          Email
                        </Typography>
                      </Label>
                      <Control
                        type="email"
                        placeholder="Enter email"
                        ref={resetEmailRef}
                      />
                      <Control.Feedback type="invalid">
                        Invalid email
                      </Control.Feedback>
                      <Control.Feedback>Looks good!</Control.Feedback>
                    </Group>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      className={classes.login}>
                      Send Reset Password Email
                    </Button>
                  </Form>
                </Modal.Body>
                <Modal.Footer>
                  <Button onClick={handleClose}>Close</Button>
                </Modal.Footer>
              </Modal>
            </Card>
            <Card className={classes.registerCard}>
              <p className={classes.registerTitle}>
                New Applicant? <Link href="/register">Register</Link>
              </p>
            </Card>
          </Col>
          <Col xs={0} sm={0} md={1} lg={2} xl={2} />
        </Row>
      </Container>
    </PageWrapper>
  );
};

export default LoginPage;
